import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TestCasesComponent } from './components/test-cases/test-cases.component';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ng2-tooltip';
import {TranslateModule} from 'ng2-translate';

import { TestCasesRouting, TestCasesRoutingProviders } from './test-cases.routes';

@NgModule({
  declarations: [TestCasesComponent],
  imports: [
    CommonModule,
    TestCasesRouting,
    BrowserModule,
    FormsModule,
    TooltipModule,
    TranslateModule
  ],
  providers: [ TestCasesRoutingProviders ]
})
export class TestCasesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/test-cases/test-cases.module.ts